<script>
export default {
  name: 'NonDynamicTransportAges',
  props: {
    ages: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      localAges: {
        infant: null,
        child: null,
      },
    };
  },
  created() {
    this.localAges = { ...this.localAges, ...this.ages };
  },
  watch: {
    localAges: {
      handler(value) {
        this.$emit('update', value);
      },
      deep: true,
    },
  },
};
</script>

<template>
  <v-layout row>
    <v-flex xs1 mr-2>
      <h5>{{ $t('nonDynamicTransport.labels.infantAge') }}:</h5>
      <v-text-field
        v-model="localAges.infant"
        :label="$t('nonDynamicTransport.labels.infantAge')"
        :hint="$t('nonDynamicTransport.labels.infantAge')"
        solo
      />
    </v-flex>
    <v-flex xs1>
      <h5>{{ $t('nonDynamicTransport.labels.childAge') }}:</h5>
      <v-text-field
        v-model="localAges.child"
        :label="$t('nonDynamicTransport.labels.childAge')"
        :hint="$t('nonDynamicTransport.labels.childAge')"
        solo
      />
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportAges.vue